module.exports = __webpack_public_path__ + "fonts/latolight.2fe27d9d.ttf";